/**
 * Estado vazio (ou de erro) que dá direção — nunca um "nada aqui" mudo.
 * Ex.: "Nenhuma proposta ainda. A primeira leva menos de dois minutos." + botão.
 */
import type { ReactNode } from 'react';

export interface EmptyStateProps {
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ title, description, action, className }: EmptyStateProps) {
  return (
    <div className={['empty', className].filter(Boolean).join(' ')}>
      <p className="empty-title display">{title}</p>
      {description ? <p className="muted">{description}</p> : null}
      {action}
    </div>
  );
}
